import { Injectable } from '@angular/core';

@Injectable()
export class TabsetConfig {
  /** provides default navigation context class: 'tabs' or 'pills' */
  public type = 'tabs';
}



// WEBPACK FOOTER //
// ./src/app/typescripts/pro/tabs-pills/tabset.config.ts